import React from "react";

import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import config from "console_config";
import useDecodedParams from "Hooks/useDecodedParams";

import * as S from "./DomainEmpty.styles";

type DomainEmptyType = {
  disableAddButton: boolean;
  supportAndDedicated: boolean;
};

const DomainEmpty = ({
  disableAddButton,
  supportAndDedicated
}: DomainEmptyType) => {
  const { organizationId, projectId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();
  const navigate = useNavigate();

  const supportUrl =
    typeof config.CUSTOM_URL_SUPPORT === "string"
      ? config.CUSTOM_URL_SUPPORT
      : "";

  const intl = useIntl();

  const addDomain = () => {
    if (!supportAndDedicated)
      navigate(`/${organizationId}/${projectId}/-/settings/domains/-/new`);
  };

  return (
    <S.EmptyDomainsWrapper>
      <S.Title tag="h2">
        {intl.formatMessage({ id: "settings.domains.add.new.title" })}
      </S.Title>
      <S.SubTitle>
        <FormattedMessage
          id="settings.domains.add.body"
          values={{
            i: txt => <i>{txt}</i>
          }}
        />
      </S.SubTitle>

      <S.AddButton
        analyticId="settings.domains.add.new.title"
        disabled={disableAddButton || supportAndDedicated ? false : true}
        id="add-new-custom-domain"
        data-testid="add-new-custom-domain"
        to={supportAndDedicated ? supportUrl : ""}
        onClick={addDomain}
      >
        {intl.formatMessage({ id: "settings.domains.add.new.title" })}
      </S.AddButton>
    </S.EmptyDomainsWrapper>
  );
};

export default DomainEmpty;
